import NAME from "./constants";

export const getIsLoading = store =>store[NAME].isLoading;
export const getRequestedDocuments = store => store[NAME].requestedDocuments || [];
export const getApprovants = store => store[NAME].approvants;
export const getLocale = store => store[NAME].locale;
export const getDateFormat = store => store[NAME].dateFormat;
